import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LayoutsModule } from './layouts/layouts.module';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LayoutsModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'private-capital';
  private translate = inject(TranslateService);

  constructor() {
    this.translate.addLangs(['hu-HU', 'en-US']);
    this.translate.setDefaultLang('en-US');
  }

  ngOnInit() {}
}
